import styled from '@emotion/styled';
import React, {FC} from 'react';
import { useSelector } from 'react-redux';
import { IEvent, IEventState } from '../../../../common/state/events/event';

type IEventPreviewAdminProps = {
    display: boolean    
}

const ContainerStyled = styled.div`
    
`;

const EventPreviewAdmin: FC<IEventPreviewAdminProps> = ({display}) => {
    const selectedEvent: IEvent | undefined = useSelector(({event}: {event: IEventState}) => event.selected);
    const descriptionHTML = React.createElement('span', {
        dangerouslySetInnerHTML: { __html: selectedEvent?.description }
      });

    return <React.Fragment>
       {Boolean(selectedEvent) && <ContainerStyled className={`${display ? 'visible' : 'hidden'} self-center flex flex-col w-3/4 justify-start items-start mt-4 p-4 bg-gray-100 dark:bg-gray-900 shadow-lg rounded-lg`}>
            <p className="text-gray-500 dark:text-gray-500 text-sm dartext-base">
                For preview only (seen by customer)*
            </p>
            <hr className="mt-2 inline-flex w-full border-dashed border-bottom border-gray-400 dark:border-gray-300"/>
            <section className="flex flex-col md:flex-row justify-around p-4">
                <article className="relative grow max-w-3/4 flex flex-col items-start">
                    <h4 className="self-start text-gray-700 dark:text-gray-400 text-md uppercase font-medium mb-2">Upcoming Leadership Seminar</h4>
                    <h2 className="my-4 text-gray-700 dark:text-teal-400 text-xl md:text-3xl uppercase font-medium mb-2">{selectedEvent?.title}</h2>
                    <p className="w-full my-4 text-gray-700 dark:text-gray-200 text-lg">                        
                        {descriptionHTML}
                    </p>
                    <button
                        className="relative bottom-0 mt-12 bg-blue-500 hover:bg-blue-400 text-white font-bold 
                                py-2 px-4 border-b-4 border-blue-700 hover:border-blue-500 rounded">
                        Click to Register
                    </button>
                </article>
                <img className="w-full md:w-1/4 rounded-lg shadow-lg my-4 " src={selectedEvent?.image_url}/>
            </section>
      </ContainerStyled>}
    </React.Fragment>
};

export default EventPreviewAdmin;